module.exports = __webpack_public_path__ + "img/logograssy.79e40ff3.png";